'use client';
import { AlertCircle } from 'lucide-react';
import { IntegrationNotice } from './IntegrationCardShell';
export function IntegrationSetupError({ message }: { message: string | null }) {
  return message ? (
    <IntegrationNotice tone="danger" icon={<AlertCircle size={16} />}>
      <span role="alert">{message}</span>
    </IntegrationNotice>
  ) : null;
}
